import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage from '../components/landing/LegalPage';

export default function Terms() {
  return (
    <LegalPage title="Terms" lastUpdated="2026-04-09">
      <h2>What this is</h2>
      <p>
        MySecureRoom is a project that is not yet available. This page exists
        today so that a waitlist can be collected legally. It is a statement
        of terms for the waitlist and the pre-launch website only.
      </p>
      <p>
        MySecureRoom is a product of Ahad Software House, a UK-based software
        studio.
      </p>

      <h2>The waitlist</h2>
      <p>
        By submitting your email to the waitlist, you're telling us you'd
        like to be notified when early access opens. You're not buying
        anything, not creating an account, and not agreeing to anything
        beyond receiving one email from us at a future date.
      </p>
      <p>
        You can remove yourself from the waitlist at any time — see the{' '}
        <Link to="/privacy">Privacy page</Link> for how.
      </p>

      <h2>No service, yet</h2>
      <p>
        MySecureRoom is not a live service today. The pre-launch website is
        a preview only. We don't guarantee that the final service will look
        like, work like, or be priced like anything you see today.
      </p>
      <p>We especially do not guarantee:</p>
      <ul>
        <li>That the service will ever launch</li>
        <li>That the features described on this site will all ship</li>
        <li>That early access will be free or paid</li>
        <li>That waitlist order determines invite order</li>
      </ul>

      <h2>Copyright</h2>
      <p>
        The content of this website — the words, the design, the code — is
        © 2026 Ahad Software House. All rights reserved.
      </p>

      <h2>Jurisdiction</h2>
      <p>
        This statement is governed by the laws of <strong>England and
        Wales</strong>. Any disputes arising from the waitlist or the
        pre-launch website are subject to the exclusive jurisdiction of the
        courts of England and Wales.
      </p>

      <h2>Changes</h2>
      <p>
        We'll update this page when we launch with a fuller set of terms
        covering the actual service.
      </p>

      <h2>Contact</h2>
      <p>
        Email <strong>khawaja.nav@gmail.com</strong> with any questions.
      </p>
    </LegalPage>
  );
}
